import { A11yModule } from '@angular/cdk/a11y';
import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  TemplateRef,
  contentChild,
  model,
  viewChild
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { SideDrawerContentDirective } from './side-drawer-content.directive';

@Component({
  selector: 'ui-side-drawer',
  imports: [MatIcon, A11yModule, NgTemplateOutlet],
  templateUrl: './side-drawer.component.html',
  styleUrl: './side-drawer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideDrawerComponent {
  public readonly contentTemplate = contentChild(SideDrawerContentDirective, { read: TemplateRef });
  public readonly drawer = viewChild.required<ElementRef>('drawerContainer');
  public readonly isOpen = model.required<boolean>();

  protected close($event?: MouseEvent): void {
    // Only trigger close if clicking actual close tab button, or clicking off the drawer
    // Prevent close when click event is child of drawer container
    if (!$event || $event.target === this.drawer().nativeElement) {
      this.isOpen.set(false);
    }
  }
}
